import {ChangeDateFormat} from "../../../Common/Helpers/ChangeDateFormat";
import i18n from "i18next";

class AdminResponseActivityCalendar {
    constructor({
                    id = '',
                    activityId = '',
                    activityName = '',
                    orgId = '',
                    orgName = '',
                    costPlace = '',
                    calendarText = '',
                    status = '',
                    organizer = '',
                    datetimeActivityFrom = "",
                    datetimeUpdate = "",
                } = {}) {
        this.id = id;
        this.activityId = activityId;
        this.activityName = activityName;
        this.orgId = orgId;
        this.orgName = orgName;
        this.costPlace = costPlace;
        this.calendarText = calendarText;
        this.status = status;
        this.organizer = organizer;
        this.organizer = organizer;
        this.datetimeActivityFrom = datetimeActivityFrom;
        this.datetimeUpdate = datetimeUpdate;   
    }

    static getAttributes(filter = null, validationSchema = null) {

        const attributes =  {
            id :{
                'label': 'ID',
                'sortable': true,
                'sortField': 'id',
                'value': (item) => item.id || "",
            },
            visualId :{
                'label': i18n.t('modelLabel.id'),
                'sortable': true,
                'sortField': 'visualId',
                'value': (item) => item.visualId || "",
            },
            activityId: {
                'label': i18n.t('modelLabel.activityId'),
                'sortable': true,
                'sortField': 'activityId',
                'value': (item) => item.activityId || "",
            },
            activityName: {
                'label': i18n.t('modelLabel.activityName'),
                'sortable': true,
                'sortField': 'activityName',
                'value': (item) => item.activityName || "",
            },
            orgId: {
                'label': 'Organization ID',
                'sortable': true,
                'sortField': 'orgId',
                'value': (item) => item.orgId || "",
            },
            orgName: {
                'label': i18n.t('modelLabel.org'),
                'sortable': true,
                'sortField': 'orgName',
                'value': (item) => item.orgName || "",
            },
            costPlace: {
                'label': i18n.t('modelLabel.costPlace'),
                'sortable': true,
                'sortField': 'costPlace',
                'value': (item) => item.costPlace || "",
            },
            status :{
                'label': i18n.t('modelLabel.status'),
                'sortable': true,
                'sortField': "status",
                'value': (item) => item.status || "",
                'type': 'select'
            },
            organizer :{
                'label': i18n.t('modelLabel.activityOrganizer'),
                'sortable': true,
                'sortField': "organizer",
                'value': (item) => item.organizer || "",
            },
            datetimeActivityFrom: {
                'label': i18n.t('modelLabel.activityfromDate'),
                'sortable': true,
                'sortField': 'datetimeActivityFrom',
                'value': (item) => item.datetimeActivityFrom ? ChangeDateFormat('dateTime', item.datetimeActivityFrom) : "" || "",
                'type': 'dateTime'
            },
            datetimeUpdate: {
                'label': i18n.t('modelLabel.updatedAt'),
                'sortable': true,
                'sortField': 'datetimeUpdate',
                'value': (item) => item.datetimeUpdate ? ChangeDateFormat('dateTime', item.datetimeUpdate) : "" || "",
                'type': 'dateTime'
            },
        };

        return attributes;
    }
}

export default AdminResponseActivityCalendar;